import { projectAgreementCancellationsAPI } from "./api";

export const getAgreementCancellations = async (params) => {
  const res = await projectAgreementCancellationsAPI.read(params);
  if (!res) return null;
  return { data: res.data, total_count: res.total_count || 0 };
};

export const getAgreementCancellationSbsProjects = async () => {
  const res = await projectAgreementCancellationsAPI.readSbsProjects();
  if (!res) return null;
  return res.data;
};

export const getAgreementCancelUspStornoWorks = async (body) => {
  const res = await projectAgreementCancellationsAPI.readUspStornoWorks(body);
  return res?.data ?? [];
};

export const buildAgreementCancelUspStorno = async (body) => {
  const res = await projectAgreementCancellationsAPI.buildUspStorno(body);
  return res?.data ?? res ?? {};
};

export const sendAgreementCancelUspStorno = async (body) => {
  const res = await projectAgreementCancellationsAPI.sendUspStorno(body);
  return res?.data ?? res ?? {};
};

export const HAS_CANCEL_OPTIONS = [
  { value: "1", label: "Есть расторжение" },
  { value: "0", label: "Нет расторжения" },
];

export const USP_BASE_OPTIONS = [
  {
    value: "https://apigw.bi.group/usp_k2_nor/hs/USPData/GetData",
    label: "УСП NOR",
  },
  {
    value: "https://apigw.bi.group/usp_k2_d/hs/USPData/GetData",
    label: "УСП D",
  },
  {
    value: "https://apigw.bi.group/usp_k2_na/hs/USPData/GetData",
    label: "УСП NA",
  },
];

export const USP_STORNO_GRANT = "M__ProjectGroupAgreementSendToUsp";

export const USP_STORNO_WARNING =
  "Журнал знает только отправки с этой страницы. Сторно через Postman здесь не видно. Сверьте выбранные работы с базой УСП, иначе можно отправить повторно.";

export const agreementCancellationColumns = [
  {
    name: "zk_name",
    field: "zk_name",
    label: "ЖК",
    align: "left",
    sortable: true,
    style: "min-width: 160px",
  },
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
    sortable: true,
    style: "min-width: 180px",
  },
  {
    name: "entrance",
    field: "entrance",
    label: "Подъезд / блок",
    align: "left",
    sortable: true,
    style: "min-width: 120px",
  },
  {
    name: "project_id",
    field: "project_id",
    label: "ID проекта",
    align: "center",
    sortable: true,
    style: "width: 110px",
  },
  {
    name: "project_status_name",
    field: "project_status_name",
    label: "Статус проекта",
    align: "center",
    sortable: true,
    style: "width: 140px",
  },
  {
    name: "agreement_num",
    field: "agreement_num",
    label: "Договор",
    align: "left",
    sortable: true,
    style: "min-width: 180px",
  },
  {
    name: "document_date",
    field: "document_date",
    label: "Дата договора",
    align: "center",
    sortable: true,
    style: "width: 130px",
  },
  {
    name: "guid",
    field: "guid",
    label: "GUID договора",
    align: "left",
    sortable: false,
    style: "min-width: 220px",
  },
  {
    name: "cancel_agreement_num",
    field: "cancel_agreement_num",
    label: "Расторжение",
    align: "left",
    sortable: true,
    style: "min-width: 160px",
  },
  {
    name: "usp_works_count",
    field: "usp_works_count",
    label: "Лог УСП",
    align: "center",
    sortable: false,
    style: "width: 150px",
  },
  {
    name: "usp_storno_sent",
    field: "usp_storno_sent",
    label: "Сторно УСП",
    align: "center",
    sortable: false,
    style: "width: 140px",
  },
  {
    name: "usp_actions",
    field: "usp_actions",
    label: "УСП",
    align: "center",
    sortable: false,
    style: "min-width: 240px",
  },
];

export const uspWorkColumns = [
  { name: "work_name", label: "Работа", field: "work_name", align: "left" },
  { name: "location_text", label: "Где сейчас", field: "location_text", align: "left" },
  { name: "log_value", label: "Value в логе", field: "log_value", align: "right" },
  { name: "vat", label: "НДС", field: "vat", align: "center" },
  { name: "work_guid", label: "Guid", field: "work_guid", align: "left" },
];
